module.exports = __webpack_public_path__ + "media/images/sponsorBanner__left__bottom-5928b8d176a7fa9a5751119feec6bdfe.png";